// La pantalla de espera ya sabe que el proximo paso es el sorteo. Adelantar ahi
// el chunk, las texturas y el decodificado del modelo saca ~1,4 MB y el decode
// del camino critico: al pulsar "Comenzar" la escena ya tiene todo en memoria.
let started = false;

export default function warmupRaffleScene() {
  if (started || typeof window === 'undefined') return;
  started = true;
  const idle = window.requestIdleCallback || (fn => setTimeout(fn, 200));
  import('./hotseat-model')
    .then(({ preloadHotSeatTextures, loadHotSeatModel }) => {
      preloadHotSeatTextures();
      // El decodificado bloquea el hilo principal, asi que espera a que la
      // pantalla de espera este ociosa en vez de competir con su cuenta atras.
      idle(() => loadHotSeatModel().catch(() => {}));
    })
    .catch(() => {});
  import('./createRaffleScene').catch(() => {});
  // El cupon y los letreros usan la misma fuente y vectores en cada sorteo.
  import('./raffleArtwork').then(({ loadRaffleArtwork }) => loadRaffleArtwork()).catch(() => {});
}
